module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBurgerMenu || _vm.isMobile),
      expression: "showBurgerMenu || isMobile"
    }],
    class: [
      'ro-header-burger',
      'button-sticky',
      {
        fixed: _vm.fixed
      }
    ]
  }, [_c('div', {
    staticClass: "button-wrap"
  }, [_c('div', {
    staticClass: "button-pulse"
  }), _vm._v(" "), _c('sky-overlay-toggle', {
    attrs: {
      "name": "menu"
    }
  }, [_c('sky-svg', {
    attrs: {
      "name": "menu"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Menu")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/vue-loader/lib/template-compiler.js?{"id":"data-v-624ea870"}!./scripts/ro-header/RoHeaderBurger.html
// module id = 372
// module chunks = 1